import { useEffect, useState } from 'react';

export const useSeller = (email) => {
    const [isSeller, setIsSeller] = useState(false);
    const [isSellerLoading, setIsSellerLoading] = useState(true);

    useEffect(() => {
        if(email){
            fetch(`${process.env.REACT_APP_API_URL}/users/seller/${email}`)
            .then(res => res.json())
            .then(data => {
                setIsSeller(data.isSeller);
                setIsSellerLoading(false)
            })
        }
    }, [email])
    return [isSeller, isSellerLoading];
};

export const useAdmin = (email) => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [isAdminLoading, setIsAdminLoading] = useState(true);

    useEffect(() => {
        if(email){
            fetch(`${process.env.REACT_APP_API_URL}/users/role/${email}`)
            .then(res => res.json())
            .then(data => {
                if(data.success){
                    if(data.role === 'admin'){
                        setIsAdmin(true);
                    } else {
                        setIsAdmin(false);
                    }
                } else {
                    setIsAdmin(false);
                }
                setIsAdminLoading(false)
            })
        }
    }, [email])
    return [isAdmin, isAdminLoading];
};

export const useDbUser = (email) => {
    const [isDbUser, setIsDbUser] = useState(null);
    const [isDbUserLoading, setIsDbUserLoading] = useState(true);
    useEffect(() => {
        if(email){
            fetch(`${process.env.REACT_APP_API_URL}/users/${email}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
            .then((res) => res.json())
            .then(data => {
                if(data.success){
                    setIsDbUser(data.data);
                } else {
                    setIsDbUser(null)
                }
                setIsDbUserLoading(false)
            })
        } else {
            setIsDbUserLoading(false)
        }
    }, [email])
    return [isDbUser, isDbUserLoading];
}
